import { getToken as getTokenLibBrowser } from 'lib-browser';

export const getToken = getTokenLibBrowser;
